export const environment = {
  // production: true,
  production: true,
  dashboardUrl: '',
  schedulerDashboardUrl: '',
  teamUrl: '',
  eventUrl: '',
  profileUrl: '',
  loggedUserDetailsUrl: '',
  chatUrl: '',
  type: '',
  eventCandidateDataUrl: '',
  activityUrl: '',
  dashboardCandidateListUrl: '',
  recruiterUrl: '',
  recruiterUrl2: '',
  recruiterGenUrl: '',
  recruiterPanelistUrl: '',
  recruiterdashboardUrl: '',
  publicationUrl: '',
  candidateListUrl: '',
  camsUrl: '',
  debugMode: false,
  apiUrl: '',
  offerDBUrl: '',
  validationUrl: '',
  createCandidateUrl: '',
  mailerServiceUrl: '',
  confirmationActivityUrl: '',
  mongoApiUrl: '',
  ExcelApiUrl: '',
  AdminUrl: '',
  parserUrl: '',
  telemetryServiceHost: '',
  keyClock: '',
  offerWF: '',
  offerTest: '',
  supportEmpUrl: '',
  careerUrl: '',
  rehireUrl: '',
  parserResumeUrl: '',
  candidateHiringNameUrl: '',
  genericApiUrl: '',
  bulkUploadApi: '',
  candidateSearchUrl: '',
  tncNewUrl: '',
  docUrl: '',
  resumePushUrl: '',
  genModelUrl: '',
  elasticUrl: "",
  marqueeEnabled: '',
  marqueeMsg: '',
  maintenanceMode: '',
  veriFace: '',
  hideShareButton: '',
  hideIBPMJB: '',
  retryDelay: ''
};
